import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AnetCommonService {
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
  ) {}
  public httpGet = <t>(url: string, config: any = {}, errorFatal_verb: string | boolean = false): Promise<t> => {
    return this.http
      .get<t>(url, config)
      .toPromise()
      .then(
        (success) => success,
        (error) => {
          throw this.handleHttpError(error, url, config, errorFatal_verb);
        },
      ) as any;
  };

  public httpGetWithTimeout = <t>(
    url: string,
    config: any = {},
    errorFatal_verb: string | boolean = false,
  ): Promise<t> => {
    return this.http
      .get<t>(url, config)
      .pipe(timeout(3000))
      .toPromise()
      .then(
        (success) => success,
        (error) => {
          throw this.handleHttpError(error, url, config, errorFatal_verb);
        },
      ) as any;
  };

  public httpPost = <t>(
    url: string,
    data: any,
    config: any = {},
    errorFatal_verb: string | boolean = false,
  ): Promise<t> => {
    return this.http
      .post<t>(url, data, config)
      .toPromise()
      .then(
        (success) => success,
        (error) => {
          throw this.handleHttpError(error, url, config, errorFatal_verb);
        },
      ) as any;
  };
  private handleHttpError = (error: any, url?: string, config: any = {}, errorFatal_verb: string | boolean = false) => {
    this.logError(error, url, config, !!errorFatal_verb);
    // if (errorFatal_verb !== false) {
    //     this.showFatalError(error, url, config, errorFatal_verb);
    // }
    return error;
  };

  public logError = (data: any, message1?: any, message2?: any, fatal = false) => {
    const url = this.document.defaultView ? this.document.defaultView.location.href : '';

    if (data && typeof data !== 'string') {
      data = JSON.stringify(data);
    }
    if (message1 && typeof message1 !== 'string') {
      message1 = JSON.stringify(message1);
    }
    if (message2 && typeof message2 !== 'string') {
      message2 = JSON.stringify(message2);
    }

    // Add 'FATAL!' to the message if appropriate
    if (fatal) {
      message1 = 'FATAL!' + (message1 ? ' ' + message1 : '');
    }

    const dataToSend = {
      Data: data,
      Message1: message1,
      Message2: message2,
      Path: url, // .replace('athletic.tv', 'athletic.net/tv').split('athletic.net')[1].split('?')[0],
      UserAgent_set: this.document.defaultView ? this.document.defaultView.navigator.userAgent : '',
    };
    this.http
      .post('/api/v1/Admin_ApiError/log', dataToSend)
      .toPromise()
      .then(
        (success) => {
          // this.anetAlert('An error has occurred and has been logged', 'Error!');
        },
        (error) => {
          // this.anetAlert("Problem contacting the Athletic.net server. Please contact support. Error Code: ErrorLogger2");
        },
      );
  };
}
